/**
 * Polyfill for URL.canParse()
 * Provides a fallback for older browsers that don't support URL.canParse
 * See: https://developer.mozilla.org/en-US/docs/Web/API/URL/canParse
 */

if (!URL.canParse) {
  URL.canParse = function (urlString, baseURL) {
    try {
      // eslint-disable-next-line no-new
      new URL(urlString, baseURL);
      return true;
    } catch {
      return false;
    }
  };
}
